import React from 'react';
import { CloseBlueImg, EditBox, EditTextArea, ImageContainer, TickBlueImg } from './CustomerCareNotes.styled';

const EditCard = ({
    value,
    CloseBlue,
    closeEditHandler,
    TickBlue,
    blueTickHandler,
    editTextHandler
}) => {
  return (
      <>
          <EditBox>
              <EditTextArea className="customer-care-note-edit-dt-mask" value={value} onChange={editTextHandler} />
              <ImageContainer>
                  <CloseBlueImg
                      src={CloseBlue}
                      onClick={closeEditHandler}
                  />
                  <TickBlueImg
                      src={TickBlue}
                      onClick={blueTickHandler}
                  />
              </ImageContainer>
          </EditBox>
      </>
  );
};

export default EditCard;